import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import enFlag from '../images/en_flag.png';
import itFlag from '../images/it_flag.png';
import { useLanguage } from '../context/LanguageContext';

function Header() {
    const { isEnLang, toggleLanguage } = useLanguage();
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    // Close menu on route change
    useEffect(() => { setMenuOpen(false); }, [location.pathname]);

    // Prevent body scroll when menu is open
    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [menuOpen]);

    const navLinks = isEnLang ? [
        { label: 'Rooms',         to: '/camere' },
        { label: 'Jacuzzi Suite', to: '/suite-jacuzzi' },
        { label: 'Breakfast',     to: '/colazione' },
        { label: 'Location',      to: '/dove-siamo' },
        { label: 'Services',      href: '/#services' },
        { label: 'Contact',       href: '/#contact' },
    ] : [
        { label: 'Camere',        to: '/camere' },
        { label: 'Suite Jacuzzi', to: '/suite-jacuzzi' },
        { label: 'Colazione',     to: '/colazione' },
        { label: 'Dove Siamo',    to: '/dove-siamo' },
        { label: 'Servizi',       href: '/#services' },
        { label: 'Contatti',      href: '/#contact' },
    ];

    return (
        <>
            <header className="site-header">
                <div className="site-header-inner l-1260">

                    <Link to="/" className="site-logo">B&amp;B Alma Suite</Link>

                    <nav className="site-nav" aria-label="Navigazione principale">
                        {navLinks.map((item, i) =>
                            item.to
                                ? <Link
                                    key={i}
                                    to={item.to}
                                    className={location.pathname === item.to ? 'active' : ''}
                                  >{item.label}</Link>
                                : <a key={i} href={item.href}>{item.label}</a>
                        )}
                    </nav>

                    <div className="site-header-actions">
                        <button
                            onClick={toggleLanguage}
                            className="lang-toggle"
                            aria-label="Cambia lingua"
                        >
                            {isEnLang
                                ? <img src={itFlag} alt="Italiano" />
                                : <img src={enFlag} alt="English" />}
                        </button>

                        <button
                            className={`hamburger${menuOpen ? ' is-open' : ''}`}
                            onClick={() => setMenuOpen(v => !v)}
                            aria-label={menuOpen ? 'Chiudi menu' : 'Apri menu'}
                            aria-expanded={menuOpen}
                        >
                            <span />
                            <span />
                            <span />
                        </button>
                    </div>
                </div>
            </header>

            {/* Mobile menu drawer */}
            <div
                className={`mobile-menu${menuOpen ? ' is-open' : ''}`}
                aria-hidden={!menuOpen}
            >
                <nav className="mobile-menu-nav" aria-label="Menu mobile">
                    {navLinks.map((item, i) =>
                        item.to
                            ? <Link key={i} to={item.to} onClick={() => setMenuOpen(false)}>{item.label}</Link>
                            : <a key={i} href={item.href} onClick={() => setMenuOpen(false)}>{item.label}</a>
                    )}
                </nav>
                <div className="mobile-menu-footer">
                    <a
                        href={`https://wa.me/+393928729907?text=${encodeURIComponent("Salve, vorrei prenotare al B&B Alma Suite. www.almasuitebb.it")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mobile-book-btn"
                    >
                        {isEnLang ? 'Book Now' : 'Prenota Ora'}
                    </a>
                </div>
            </div>
        </>
    );
}

export default Header;
